import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { JCADashboard } from '../../../features/jca'
import { JCADetailWrapper as JCADetail } from '../../../features/jca-detail'

export const JCARouter = () => {
  return (
    <Routes>
      <Route exact path="/" element={<JCADashboard />} />
      <Route exact path="/:jcaId" element={<JCADetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
